import * as yup from 'yup';


const ListServiceSchema = yup.object({

  // image : yup.mixed().required("image is required"),

  biography: yup
      .string('Enter your biography')
      .required('Biography is required')

  ,
  type:yup.array().of(yup.string('Type of artist').required('Type of artist is required'))
    
  ,
  gender: yup
      .string('Gender').required("Gender is required"),

  location: yup
      .string('Location').required("Location is required"),
  language: yup.array().of(yup.string('languages')).required("Languages is required"),
  skills:yup
    .array().of(yup.string('Skills')).required("Skills are required"),
  linkedin: yup.string('Linkedin').matches(/linkedin.com/, "Please enter valid Linkedin url").url("The link must be a valid url"),
  portfolio: yup.string('Portfolio').url("The link must be a valid url"),
  imdb: yup.string('imdb').matches(/imdb.com/, "Please enter valid IMDb url").url("The link must be a valid url"),
  other: yup.string('Other links').url("The link must be a valid url"),
  bd_country: yup.string('Country'),
  bd_bankName: yup.string('Bank name'),
  bd_accountTitle: yup.string('Account title'),
  bd_accountNumber: yup.string('Account number'),
  bd_swiftCode: yup.string('BIC / Swift code').min(4 , "A valid BIC must have atleast 4 characters").max(11 , "A valid BIC must have maximum 11 characters"),
  bd_recipientFullName: yup.string('Recipient`s full name'),
  bd_recipientAddress: yup.string('Recipient`s address'),
});


const initialValues = {
  image : '',
  biography: '',
  type: [],
  gender: '',
  location: '',
  language: [],
  skills: [],
  linkedin: '',
  portfolio: '',
  imdb: '',
  other: '',
  bd_country:'',
  bd_bankName:'',
  bd_accountTitle:'',
  bd_accountNumber:'',
  bd_swiftCode:'',
  bd_recipientFullName:'',
  bd_recipientAddress:'',
}

const ListServiceValidation = {initialValues, ListServiceSchema}
export default ListServiceValidation;